import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BodyComponent } from './component/body/body.component';
import { SidebarComponent } from './component/sidebar/sidebar.component';
import { ToolbarComponent } from './component/toolbar/toolbar.component';
import { HeaderComponent } from './component/header/header.component';
import { RouterModule } from '@angular/router';
import {
  CustomRangePanelComponent,
  DateFilterComponent,
} from './ui/date-filter/date-filter.component';
import { HomeComponent } from '../modules/home/home.component';
import { AppointmentComponent } from '../modules/appointment/appointment.component';
import { LeadComponent } from '../modules/lead/lead.component';
import { LeadProfilePageComponent } from '../modules/lead/lead-profile-page/lead-profile-page.component';
import { UsersComponent } from '../modules/configuration/users/users.component';
import { materialModules } from './module';
import { ScheduleComponent } from '../modules/configuration/schedule/schedule.component';
import { CampaignManagementComponent } from '../modules/components/campaign-management/campaign-management.component';
import { SubcriberComponent } from '../modules/components/subcriber/subcriber.component';
import { CampaignComponent } from '../modules/components/campaign/campaign.component';
import { EmailSettingsComponent } from '../modules/configuration/email-settings/email-settings.component';
import { CreateAppointmentComponent } from '../modules/components/create-appointment/create-appointment.component';
import { AppointmentDetailComponent } from '../modules/components/appointment-detail/appointment-detail.component';
import { LeadFormComponent } from 'src/app/public/lead-form/lead-form.component';
import { CustomerActivityCaptureComponent } from 'src/app/public/customer-activity-capture/customer-activity-capture.component';
import { NotFoundComponent } from 'src/app/public/not-found/not-found.component';
import { UnauthorizedComponent } from 'src/app/public/unauthorized/unauthorized.component';
import { LeadsComponent } from '../modules/configuration/leads/leads.component';
import { RegistrationComponent } from '../modules/configuration/registration/registration.component';
import { WhatsappComponent } from '../modules/configuration/whatsapp/whatsapp.component';
import { ContactsComponent } from '../modules/contacts/contacts.component';
import { ContactProfilePageComponent } from '../modules/contacts/contact-profile-page/contact-profile-page.component';
import { UserLogsComponent } from '../modules/user-logs/user-logs.component';
import { ExcelUploadComponent } from '../modules/components/excel-upload/excel-upload.component';
import { CommunicationModelComponent } from 'src/app/private/modules/components/communication-model/communication-model.component';
import { RingoverCallComponent } from 'src/app/private/modules/components/ringover-call/ringover-call.component';
import { LeadEmailComponent } from 'src/app/private/modules/components/lead-email/lead-email.component';
import { LeadWhatsappComponent } from 'src/app/private/modules/components/lead-whatsapp/lead-whatsapp.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { CommunicationLogsComponent } from 'src/app/private/modules/components/communication-logs/communication-logs.component';
import { SalesMailHubComponent } from 'src/app/private/modules/configuration/sales-mail-hub/sales-mail-hub.component';
import { MailLeftActionsComponent } from 'src/app/private/modules/components/sales-mail-hub/mail-left-actions/mail-left-actions.component';
import { MailRightTableComponent } from 'src/app/private/modules/components/sales-mail-hub/mail-right-table/mail-right-table.component';
import { MailMiddleSectionComponent } from 'src/app/private/modules/components/sales-mail-hub/mail-middle-section/mail-middle-section.component';
import { MailRightSectionComponent } from 'src/app/private/modules/components/sales-mail-hub/mail-right-section/mail-right-section.component';
import { TicketsComponent } from 'src/app/private/modules/tickets/tickets.component';
import { CreateTicketComponent } from 'src/app/private/modules/components/ticket-module/create-ticket/create-ticket.component';
import { AddCommentComponent } from 'src/app/private/modules/components/ticket-module/add-comment/add-comment.component';
import { AddContactsGroupComponent } from '../modules/components/add-contacts-group/add-contacts-group.component';
import { ContactGroupListComponent } from '../modules/components/contact-group-list/contact-group-list.component';
import { CreataeWhatsappTemplateComponent } from '../modules/components/creatae-whatsapp-template/creatae-whatsapp-template.component';
import { CreateBroadcastCampaignComponent } from '../modules/components/create-broadcast-campaign/create-broadcast-campaign.component';
import { CreateContactGroupComponent } from '../modules/components/create-contact-group/create-contact-group.component';
import { CreateEmailTemplateComponent } from '../modules/components/create-email-template/create-email-template.component';
import { CreateEventComponent } from '../modules/components/create-event/create-event.component';
import { CsvDropzoneComponent } from '../modules/components/csv-dropzone/csv-dropzone.component';
import { PreviewEmailTemplateComponent } from '../modules/components/preview-email-template/preview-email-template.component';
import { PreviewWhatsappTemplateComponent } from '../modules/components/preview-whatsapp-template/preview-whatsapp-template.component';
import { RingOverComponent } from '../modules/components/ring-over/ring-over.component';
import { BroadcastCampaignComponent } from '../modules/configuration/broadcast-campaign/broadcast-campaign.component';
import { CampaignSegmentsComponent } from '../modules/configuration/campaign-segments/campaign-segments.component';
import { ContactGroupsComponent } from '../modules/configuration/contact-groups/contact-groups.component';
import { EmailTemplateComponent } from '../modules/configuration/email-template/email-template.component';
import { WhatsappTemplateComponent } from '../modules/configuration/whatsapp-template/whatsapp-template.component';
import { WhatsappVoiceCampaignComponent } from '../modules/configuration/whatsapp-voice-campaign/whatsapp-voice-campaign.component';
import { EventsComponent } from '../modules/events/events.component';
import { WoocommerceInventoryComponent } from '../modules/woocommerce-inventory/woocommerce-inventory.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ManageWooOrdersComponent } from '../modules/manage-woo-orders/manage-woo-orders.component';
import { EmailEditorModule } from 'angular-email-editor';
import { MatTooltip } from '@angular/material/tooltip';
import { SafeUrlPipe } from 'src/app/safe-url.pipe';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SignatureModelComponent } from 'src/app/private/modules/components/signature-model/signature-model.component';
import { PreviewSignatureModelComponent } from 'src/app/private/modules/components/preview-signature-model/preview-signature-model.component';
import { CompanyComponent } from 'src/app/private/modules/configuration/company/company.component';
import { CreateCompanyComponent } from 'src/app/private/modules/components/company/create-company/create-company.component';
import { DealsComponent } from 'src/app/private/modules/deals/deals.component';
import { InvoiceComponent } from 'src/app/private/modules/invoice/invoice.component';
import { QuoteComponent } from 'src/app/private/modules/quote/quote.component';
import { CreateDealsComponent } from 'src/app/private/modules/components/deals/create-deals/create-deals.component';
import { CreateInvoiceComponent } from 'src/app/private/modules/components/invoice/create-invoice/create-invoice.component';
import { CreateQuoteComponent } from 'src/app/private/modules/components/quote/create-quote/create-quote.component';
import { AddContactComponent } from 'src/app/private/modules/components/add-contact/add-contact.component';
import { AutoCompleteSearchComponent } from 'src/app/private/modules/components/auto-complete-search/auto-complete-search.component';
import { ConvertToAccountComponent } from 'src/app/private/modules/components/convert-to-account/convert-to-account.component';
import { AutoCompleteContactSearchComponent } from 'src/app/private/modules/components/auto-complete-contact-search/auto-complete-contact-search.component';
import { PipelineComponent } from 'src/app/private/modules/configuration/pipeline/pipeline.component';
import { CreateNewPipelineComponent } from 'src/app/private/modules/components/create-new-pipeline/create-new-pipeline.component';
import { AddStageComponent } from 'src/app/private/modules/components/add-stage/add-stage.component';
import { ContentInfoComponent } from 'src/app/private/modules/components/content-info/content-info.component';
import { ClickOutsideDirective } from 'src/app/click-outside.directive';
import { OutsideHoverDirective } from 'src/app/outside-hover.directive';
import { TableLoadingDirective } from './directives/table-loading.directive';
import { AppendToBodyDirective } from './directives/append-to-body.directive';

import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { KanbanBoardComponent } from '../modules/components/kanban-board/kanban-board.component';
import { DealsKanbanDashboardComponent } from 'src/app/private/modules/components/kanban-boards/deals-kanban-dashboard/deals-kanban-dashboard.component';
import { DropZoneForLeadsComponent } from 'src/app/private/modules/components/drop-zone-for-leads/drop-zone-for-leads.component';
import { ColumnInfoForLeadComponent } from 'src/app/private/modules/components/column-info-for-lead/column-info-for-lead.component';
import { ProductsComponent } from 'src/app/private/modules/products/products.component';
import { CreateProductComponent } from 'src/app/private/modules/components/product/create-product/create-product.component';
import { ProductInfoComponent } from 'src/app/private/modules/components/product-info/product-info.component';
import { CategoryComponent } from 'src/app/private/modules/configuration/category/category.component';
import { CreateCategoryComponent } from 'src/app/private/modules/components/category/create-category/create-category.component';
import { TaxesComponent } from 'src/app/private/modules/configuration/taxes/taxes.component';
import { CreateTaxesComponent } from 'src/app/private/modules/components/taxes/create-taxes/create-taxes.component';
import { BulkUpdateLeadComponent } from 'src/app/private/modules/components/leads/bulk-update-lead/bulk-update-lead.component';
import { AddTaskComponent } from 'src/app/private/modules/components/leads/add-task/add-task.component';
import { AddNoteComponent } from 'src/app/private/modules/components/leads/add-note/add-note.component';
import { LeadTasksComponent } from 'src/app/private/modules/components/leads/lead-tasks/lead-tasks.component';
import { LeadNotesComponent } from 'src/app/private/modules/components/leads/lead-notes/lead-notes.component';
import { AddCommunicationLogComponent } from 'src/app/private/modules/components/leads/add-communication-log/add-communication-log.component';
import { LeadKanbanDahboardComponent } from 'src/app/private/modules/components/kanban-boards/lead-kanban-dahboard/lead-kanban-dahboard.component';
import { LeadMettingComponent } from 'src/app/private/modules/components/leads/lead-metting/lead-metting.component';
import { AddLeadMettingComponent } from 'src/app/private/modules/components/leads/add-lead-metting/add-lead-metting.component';
import { ManageTeamsComponent } from 'src/app/private/modules/configuration/manage-teams/manage-teams.component';
import { TeamListComponent } from 'src/app/private/modules/components/teams/team-list/team-list.component';
import { CreateTeamComponent } from 'src/app/private/modules/components/teams/create-team/create-team.component';
import { AddMembersComponent } from 'src/app/private/modules/components/teams/add-members/add-members.component';
import { UpdateTeamComponent } from 'src/app/private/modules/components/teams/update-team/update-team.component';
import { ForecastComponent } from 'src/app/private/modules/forecast/forecast.component';
import { CreateForecastComponent } from 'src/app/private/modules/components/forecast/create-forecast/create-forecast.component';
import { ViewForecastComponent } from 'src/app/private/modules/components/forecast/view-forecast/view-forecast.component';
import { FilterDrawerComponent } from 'src/app/private/modules/components/leads/filter-drawer/filter-drawer.component';
import { BulkDeleteComponent } from 'src/app/private/modules/components/leads/bulk-delete/bulk-delete.component';
import { SequencesComponent } from '../modules/configuration/sequences/sequences.component';
import { SequenceDetailComponent } from '../modules/configuration/sequence-detail/sequence-detail.component';
import { DeleteTaskComponent } from '../modules/components/leads/delete-task/delete-task.component';
import { ReportComponent } from 'src/app/private/modules/report/report.component';
import { ReportLeftSectionComponent } from 'src/app/private/modules/components/report/report-left-section/report-left-section.component';
import { LeadsReportComponent } from 'src/app/private/modules/components/report/leads-report/leads-report.component';
import { DealsReportComponent } from 'src/app/private/modules/components/report/deals-report/deals-report.component';
import { ContactsReportComponent } from 'src/app/private/modules/components/report/contacts-report/contacts-report.component';
import { TicketsReportComponent } from 'src/app/private/modules/components/report/tickets-report/tickets-report.component';
import { LeadReportDetailsComponent } from 'src/app/private/modules/components/report/lead-report-details/lead-report-details.component';
import { DealsReportDetailsComponent } from 'src/app/private/modules/components/report/deals-report-details/deals-report-details.component';
import { TicketDetailsReportComponent } from 'src/app/private/modules/components/report/ticket-details-report/ticket-details-report.component';
import { AnalyticsComponent } from 'src/app/private/modules/analytics/analytics.component';
import { ChartWithCircleComponent } from 'src/app/private/modules/components/analytics/chart-with-circle/chart-with-circle.component';
import { PieChartComponent } from 'src/app/private/modules/components/analytics/pie-chart/pie-chart.component';
import { LeadTimeChartComponent } from 'src/app/private/modules/components/analytics/lead-time-chart/lead-time-chart.component';
import { BarChartComponent } from 'src/app/private/modules/components/analytics/bar-chart/bar-chart.component';
import { CampaignReportComponent } from 'src/app/private/modules/components/report/campaign/campaign-report/campaign-report.component';
import { MarketingAnalyticsReportComponent } from 'src/app/private/modules/components/report/marketing-analytics/marketing-analytics-report.component';
import { CampaignReportDetailsComponent } from 'src/app/private/modules/components/report/campaign/campaign-report-details/campaign-report-details.component';
import { DomainAuthenticationComponent } from 'src/app/private/modules/configuration/domain-authentication/domain-authentication.component';
import { AddAuthDomainComponent } from 'src/app/private/modules/components/auth-domain/add-auth-domain/add-auth-domain.component';
import { ManageAccountFieldComponent } from 'src/app/private/modules/configuration/manage-account-field/manage-account-field.component';
import { ManageContactFieldComponent } from 'src/app/private/modules/configuration/manage-contact-field/manage-contact-field.component';
import { ContactBulkImportComponent } from 'src/app/private/modules/components/bulk-imports/contact-bulk-import/contact-bulk-import.component';
import { ConvertToGroupComponent } from 'src/app/private/modules/components/leads/convert-to-group/convert-to-group.component';
import { LeadDetailsHoverPopupComponent } from 'src/app/private/modules/components/leads/lead-details-hover-popup/lead-details-hover-popup.component';
import { CreateContactGroupFromLeadsComponent } from 'src/app/private/modules/components/leads/create-contact-group-from-leads/create-contact-group-from-leads.component';
import { CreateContactGroupFromContactsComponent } from 'src/app/private/modules/components/contacts/create-contact-group-from-contacts/create-contact-group-from-contacts.component';
import { RemoveDuplicateLeadsComponent } from 'src/app/private/modules/components/leads/remove-duplicate-leads/remove-duplicate-leads.component';
import { LeadActivityChartComponent } from 'src/app/private/modules/components/leads/lead-activity-chart/lead-activity-chart.component';
import { LeadProfileComponent } from 'src/app/private/modules/components/leads/lead-profile/lead-profile.component';
import { LeadTimelineComponent } from 'src/app/private/modules/components/leads/lead-timeline/lead-timeline.component';
import { LeadProfileFollowupComponent } from 'src/app/private/modules/components/leads/lead-profile-followup/lead-profile-followup.component';
import { LeadProfileOverviewComponent } from 'src/app/private/modules/components/leads/lead-profile-overview/lead-profile-overview.component';
import { LeadStageStepperComponent } from 'src/app/private/modules/components/leads/lead-stage-stepper/lead-stage-stepper.component';
import { LeadStatusTabsComponent } from 'src/app/private/modules/components/leads/lead-status-tabs/lead-status-tabs.component';
import { LeadActivityFeedComponent } from 'src/app/private/modules/components/leads/lead-activity-feed/lead-activity-feed.component';
import { LeadProfileActivityPanelComponent } from 'src/app/private/modules/components/leads/lead-profile-activity-panel/lead-profile-activity-panel.component';
import { LeadProfileTransactionsComponent } from 'src/app/private/modules/components/leads/lead-profile-transactions/lead-profile-transactions.component';
import { LeadProfileLoyaltyComponent } from 'src/app/private/modules/components/leads/lead-profile-loyalty/lead-profile-loyalty.component';
import { LeadProfileTicketsComponent } from 'src/app/private/modules/components/leads/lead-profile-tickets/lead-profile-tickets.component';
import { LeadProfileFeedbackComponent } from 'src/app/private/modules/components/leads/lead-profile-feedback/lead-profile-feedback.component';
import { LeadProfileSupportComponent } from 'src/app/private/modules/components/leads/lead-profile-support/lead-profile-support.component';
import { LeadProfileDocumentsComponent } from 'src/app/private/modules/components/leads/lead-profile-documents/lead-profile-documents.component';
import { LeadProfileAnalyticsComponent } from 'src/app/private/modules/components/leads/lead-profile-analytics/lead-profile-analytics.component';
import { AddEmailToDomainComponent } from 'src/app/private/modules/components/auth-domain/add-email-to-domain/add-email-to-domain.component';
import { ConnectEmailAccountComponent } from 'src/app/private/modules/components/leads/connect-email-account/connect-email-account.component';
import { DealsBulkImportComponent } from 'src/app/private/modules/components/deals/deals-bulk-import/deals-bulk-import.component';
import { ProjectComponent } from '../modules/project/project.component';
import { ProjectFormComponent } from '../modules/components/project/project-form.component';
import { ProjectDetailComponent } from '../modules/project/project-detail/project-detail.component';
import { ProjectDetailTasksComponent } from '../modules/project/project-detail/project-detail-tasks/project-detail-tasks.component';
import { ProjectDetailSprintComponent } from '../modules/project/project-detail/project-detail-sprint/project-detail-sprint.component';
import { ProjectDetailKanbanComponent } from '../modules/project/project-detail/project-detail-kanban/project-detail-kanban.component';
import { ProjectDetailBugsComponent } from '../modules/project/project-detail/project-detail-bugs/project-detail-bugs.component';
import { ProjectDetailMembersComponent } from '../modules/project/project-detail/project-detail-members/project-detail-members.component';
import { ProjectTasksComponent } from '../modules/components/project-tasks/project-tasks.component';
import { ProjectTaskCommentComponent } from '../modules/components/project-tasks/project-task-comment/project-task-comment.component';
import { ProjectTaskTimeLogComponent } from '../modules/components/project-tasks/project-task-time-log/project-task-time-log.component';
import { ProjectTaskItemComponent } from '../modules/components/project-tasks/project-task-item/project-task-item.component';
import { ProjectTaskActivityComponent } from '../modules/components/project-tasks/project-task-activity/project-task-activity.component';
import { BugsComponent } from '../modules/components/bugs/bug-listing/bugs.component';
import { BugFormComponent } from '../modules/components/bugs/bug-form/bug-form.component';
import { DragDropFileUploaderComponent } from '../modules/components/drag-drop-file-uploader/drag-drop-file-uploader.component';
import { AttachmentPreviewModalComponent } from '../modules/components/attachment-preview-modal/attachment-preview-modal.component';
import { BugActivityTimelineComponent } from '../modules/components/bugs/bug-activity-timeline/bug-activity-timeline.component';
import { LineChartComponent } from '../modules/project-reports/components/line-chart/line-chart.component';
import { ReportCardsComponent } from '../modules/project-reports/components/report-cards/report-cards.component';
import { ProjectReportComponent } from '../modules/project-reports/project-report/project-report.component';
import { TrendReportComponent } from '../modules/project-reports/components/trend-report/trend-report.component';
import { BugPieChartComponent } from '../modules/project-reports/components/bug-pie-chart/bug-pie-chart.component';
import { ClientSettingComponent } from '../modules/configuration/client-setting/client-setting.component';
import { EmailConfigComponent } from '../modules/components/email-config/email-config.component';
import { WhatsappConfigComponent } from '../modules/components/whatsapp-config/whatsapp-config.component';
import { ConfirmEmailServiceComponent } from '../modules/components/confirm-email-service/confirm-email-service.component';
import { CommunicationConfigComponent } from '../modules/components/communication-config/communication-config.component';
import { SubscriptionBillingComponent } from '../modules/configuration/subscription-billing/subscription-billing.component';
import { EmailCampaignAnlayticsComponent } from '../modules/components/email-campaign-anlaytics/email-campaign-anlaytics.component';
import { RoleBasedAccessControlComponent } from '../modules/configuration/role-based-access-control/role-based-access-control.component';
import { WhatsappCampaignAnalyticsComponent } from '../modules/components/whatsapp-campaign-analytics/whatsapp-campaign-analytics.component';
import { CallCampaignAnalyticsComponent } from '../modules/components/call-campaign-analytics/call-campaign-analytics.component';
import { ManageDepartmentsComponent } from '../modules/configuration/manage-departments/manage-departments.component';
import { ManageCentersComponent } from '../modules/configuration/manage-centers/manage-centers.component';
import { ManageBussinessInfoComponent } from '../modules/configuration/manage-bussiness-info/manage-bussiness-info.component';
import { WebLiveChatComponent } from '../modules/web-live-chat/web-live-chat.component';
import { WhiteLabelPanelComponent } from './component/white-label-panel/white-label-panel.component';
import { WhatsappLiveChatComponent } from '../modules/whatsapp-live-chat/whatsapp-live-chat.component';
import { RowActionDropdownComponent } from './component/row-action-dropdown/row-action-dropdown.component';
import { IntegrationsComponent } from '../modules/integrations/integrations.component';
import { ComingSoonComponent } from '../modules/coming-soon/coming-soon.component';
import { Audience360AnalyticsComponent } from '../modules/components/analytics/audience-360-analytics/audience-360-analytics.component';
import { CustomerIntelligenceComponent } from '../modules/customer-intelligence/customer-intelligence.component';

@NgModule({
  declarations: [
    HeaderComponent,
    BodyComponent,
    SafeUrlPipe,
    SidebarComponent,
    ToolbarComponent,
    DateFilterComponent,
    CustomRangePanelComponent,
    HomeComponent,
    LeadComponent,
    LeadProfilePageComponent,
    UsersComponent,
    CampaignManagementComponent,
    EmailSettingsComponent,
    SubcriberComponent,
    CampaignComponent,
    ScheduleComponent,
    AppointmentComponent,
    CreateAppointmentComponent,
    AppointmentDetailComponent,
    LeadsComponent,
    RegistrationComponent,
    LeadFormComponent,
    CustomerActivityCaptureComponent,
    NotFoundComponent,
    UnauthorizedComponent,
    WhatsappComponent,
    ContactsComponent,
    ContactProfilePageComponent,
    UserLogsComponent,
    ExcelUploadComponent,
    CommunicationModelComponent,
    RingoverCallComponent,
    LeadEmailComponent,
    LeadWhatsappComponent,
    CommunicationLogsComponent,
    SalesMailHubComponent,
    MailLeftActionsComponent,
    MailRightTableComponent,
    MailMiddleSectionComponent,
    MailRightSectionComponent,
    TicketsComponent,
    CreateTicketComponent,
    AddCommentComponent,
    WhatsappTemplateComponent,
    CreataeWhatsappTemplateComponent,
    EventsComponent,
    CreateEventComponent,
    EmailTemplateComponent,
    CreateEmailTemplateComponent,
    ContactGroupsComponent,
    CreateContactGroupComponent,
    AddContactsGroupComponent,
    BroadcastCampaignComponent,
    CampaignSegmentsComponent,
    CreateBroadcastCampaignComponent,
    WhatsappVoiceCampaignComponent,
    ContactGroupListComponent,
    CsvDropzoneComponent,
    PreviewWhatsappTemplateComponent,
    RingOverComponent,
    PreviewEmailTemplateComponent,
    WoocommerceInventoryComponent,
    ManageWooOrdersComponent,
    SignatureModelComponent,
    PreviewSignatureModelComponent,
    CompanyComponent,
    CreateCompanyComponent,
    DealsComponent,
    CreateDealsComponent,
    InvoiceComponent,
    CreateInvoiceComponent,
    QuoteComponent,
    CreateQuoteComponent,
    AddContactComponent,
    AutoCompleteSearchComponent,
    ConvertToAccountComponent,
    AutoCompleteContactSearchComponent,
    PipelineComponent,
    CreateNewPipelineComponent,
    AddStageComponent,
    ContentInfoComponent,
    KanbanBoardComponent,
    DealsKanbanDashboardComponent,
    DropZoneForLeadsComponent,
    ColumnInfoForLeadComponent,
    ProductsComponent,
    CreateProductComponent,
    ProductInfoComponent,
    CategoryComponent,
    CreateCategoryComponent,
    TaxesComponent,
    CreateTaxesComponent,
    BulkUpdateLeadComponent,
    AddTaskComponent,
    AddNoteComponent,
    LeadTasksComponent,
    LeadNotesComponent,
    AddCommunicationLogComponent,
    LeadKanbanDahboardComponent,
    LeadMettingComponent,
    AddLeadMettingComponent,
    ManageTeamsComponent,
    TeamListComponent,
    CreateTeamComponent,
    AddMembersComponent,
    UpdateTeamComponent,
    ForecastComponent,
    CreateForecastComponent,
    ViewForecastComponent,
    FilterDrawerComponent,
    BulkDeleteComponent,
    SequencesComponent,
    SequenceDetailComponent,
    DeleteTaskComponent,
    ReportComponent,
    ReportLeftSectionComponent,
    LeadsReportComponent,
    DealsReportComponent,
    ContactsReportComponent,
    TicketsReportComponent,
    LeadReportDetailsComponent,
    DealsReportDetailsComponent,
    TicketDetailsReportComponent,
    AnalyticsComponent,
    Audience360AnalyticsComponent,
    CustomerIntelligenceComponent,
    ChartWithCircleComponent,
    PieChartComponent,
    LeadTimeChartComponent,
    BarChartComponent,
    CampaignReportComponent,
    MarketingAnalyticsReportComponent,
    CampaignReportDetailsComponent,
    DomainAuthenticationComponent,
    AddAuthDomainComponent,
    ManageAccountFieldComponent,
    ManageContactFieldComponent,
    ContactBulkImportComponent,
    ConvertToGroupComponent,
    LeadDetailsHoverPopupComponent,
    CreateContactGroupFromLeadsComponent,
    CreateContactGroupFromContactsComponent,
    RemoveDuplicateLeadsComponent,
    LeadActivityChartComponent,
    LeadProfileComponent,
    LeadTimelineComponent,
    LeadProfileFollowupComponent,
    LeadProfileOverviewComponent,
    LeadStageStepperComponent,
    LeadStatusTabsComponent,
    LeadActivityFeedComponent,
    LeadProfileActivityPanelComponent,
    LeadProfileTransactionsComponent,
    LeadProfileLoyaltyComponent,
    LeadProfileTicketsComponent,
    LeadProfileFeedbackComponent,
    LeadProfileSupportComponent,
    LeadProfileDocumentsComponent,
    LeadProfileAnalyticsComponent,
    AddEmailToDomainComponent,
    ConnectEmailAccountComponent,
    DealsBulkImportComponent,
    InvoiceComponent,
    QuoteComponent,
    ProjectComponent,
    ProjectFormComponent,
    ProjectDetailComponent,
    ProjectDetailTasksComponent,
    ProjectDetailSprintComponent,
    ProjectDetailKanbanComponent,
    ProjectDetailBugsComponent,
    ProjectDetailMembersComponent,
    BugsComponent,
    ProjectTasksComponent,
    ProjectTaskCommentComponent,
    ProjectTaskTimeLogComponent,
    ProjectTaskItemComponent,
    ProjectTaskActivityComponent,
    BugFormComponent,
    DragDropFileUploaderComponent,
    AttachmentPreviewModalComponent,
    BugActivityTimelineComponent,
    ProjectReportComponent,
    ReportCardsComponent,
    PieChartComponent,
    BarChartComponent,
    LineChartComponent,
    TrendReportComponent,
    BugPieChartComponent,
    ClientSettingComponent,
    EmailConfigComponent,
    WhatsappConfigComponent,
    ConfirmEmailServiceComponent,
    CommunicationConfigComponent,
    SubscriptionBillingComponent,
    EmailCampaignAnlayticsComponent,
    RoleBasedAccessControlComponent,
    WhatsappCampaignAnalyticsComponent,
    CallCampaignAnalyticsComponent,
    ManageDepartmentsComponent,
    ManageCentersComponent,
    ManageBussinessInfoComponent,
    WebLiveChatComponent,
    WhiteLabelPanelComponent,
    WhatsappLiveChatComponent,
    IntegrationsComponent,
    ComingSoonComponent,
    TableLoadingDirective,
    RowActionDropdownComponent,
  ],

  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    NgMultiSelectDropDownModule.forRoot(),
    DragDropModule,
    RouterModule,
    NgxIntlTelInputModule,
    CKEditorModule,
    EmailEditorModule,
    NgxDropzoneModule,
    ClickOutsideDirective,
    OutsideHoverDirective,
    AppendToBodyDirective,
    ...materialModules,
  ],

  schemas: [NO_ERRORS_SCHEMA],
  exports: [
    HeaderComponent,
    BodyComponent,
    SidebarComponent,
    ToolbarComponent,
    ClickOutsideDirective,
    OutsideHoverDirective,
    AppendToBodyDirective,
    WhiteLabelPanelComponent,
    TableLoadingDirective,
    RowActionDropdownComponent,
    CreateBroadcastCampaignComponent,
    WhatsappVoiceCampaignComponent,
  ],
})
export class SharedModule {}
